import React from "react";
import { default as MuiCardActions } from "@mui/material/CardActions";

function CardActions(props) {
  return <MuiCardActions {...props} />;
}

export default CardActions;
